import { render } from "./CanselRetireFornView.vue?vue&type=template&id=472aa9ff&scoped=true"
import script from "./CanselRetireFornView.vue?vue&type=script&lang=js"
export * from "./CanselRetireFornView.vue?vue&type=script&lang=js"

import "./CanselRetireFornView.vue?vue&type=style&index=0&id=472aa9ff&scoped=true&lang=css"

import exportComponent from "/home/timecard-prod/OggiTimeClockSystem/electron/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-472aa9ff"]])

export default __exports__